import IconVisa from "../../Assets/SVGs/Icons/CreditCards/Visa";
import IconMasterCard from "../../Assets/SVGs/Icons/CreditCards/MasterCard";
import IconAmex from "../../Assets/SVGs/Icons/CreditCards/Amex";
import IconDiscover from "../../Assets/SVGs/Icons/CreditCards/Discover";
import IconJCB from "../../Assets/SVGs/Icons/CreditCards/JCB";
import IconDIners from "../../Assets/SVGs/Icons/CreditCards/Diners";
import IconGenericCC from "../../Assets/SVGs/Icons/CreditCards/GenericCC";

const ZERO_DECIMAL_CURRENCIES = new Set([
    "BIF","CLP","DJF","GNF","JPY","KMF","KRW","MGA","PYG","RWF","UGX","VND","VUV","XAF","XOF","XPF"
]);

export function formatMoney(
    amount: number | null | undefined,
    currency: string | null | undefined,
    units: "minor" | "major" = "minor"
) {
    if (amount == null || currency == null) return null;
    const c = currency.toUpperCase();
    const zeroDecimal = ZERO_DECIMAL_CURRENCIES.has(c);
    const divisor = zeroDecimal ? 1 : 100;
    const value = units === "minor" ? amount / divisor : amount;

    try {
        const formatted = new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: c,
            currencyDisplay: "symbol",
        }).format(value);
        return formatted.endsWith(".00") ? formatted.slice(0, -3) : formatted;
    } catch {
        const sym = c === "GBP" ? "£" : "";
        const fallback = `${sym}${value.toFixed(2)}`;
        return fallback.endsWith(".00") ? fallback.slice(0, -3) : fallback;
    }
}

/**
 * Returns an SVG for the given card brand, or a default icon if unknown.
 */
export function getCardBrandIcon(brand: string): JSX.Element {
    const normalized = (brand || "")
        .toString()
        .trim()
        .toLowerCase();

    switch (normalized) {
        case "visa":
            // return <VisaIcon {...svgProps} />;
            return IconVisa({className: 'icon--credit-card'});

        case "mastercard":
            // return <MastercardIcon {...svgProps} />;
            return IconMasterCard({className: 'icon--credit-card'});

        case "amex":
        case "american_express":
            // return <AmexIcon {...svgProps} />;
            return IconAmex({className: 'icon--credit-card'});

        case "discover":
            // return <DiscoverIcon {...svgProps} />;
            return IconDiscover({className: 'icon--credit-card'});

        case "jcb":
            // return <JcbIcon {...svgProps} />;
            return IconJCB({className: 'icon--credit-card'});

        case "diners":
        case "diners_club":
            // return <DinersIcon {...svgProps} />;
            return IconDIners({className: 'icon--credit-card'});

        case "":
        case "unknown":
        default:
            // return <DefaultCardIcon {...svgProps} />;
            return IconGenericCC({className: 'icon--credit-card'});
    }
}
